import { UrlConstants } from "../url.constants";
export class ApiAttachmentConstants {
    static URL = UrlConstants.API_V2 + "Attachment";
    static FUNCTION_DELETE_MULTIPLE_ATTACHMENTS = "DeleteMultipleAttachments";
    static FUNCTION_GET_ATTACHMENT_CONTENT = "GetAttachmentContent";
    static FUNCTION_UPLOAD_ATTACHMENT = "UploadAttachment";
    static FUNCTION_UPLOAD_ATTACHMENT_FROM_PORTAL = "UploadAttachmentFromAFLAPortal";
    static FUNCTION_GET_MY_AFLA_PORTAL_DOCUMENTS = "GetMyAFLAPortalDocuments";
}
